import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import Button from '../button';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCookieConfig,
  setModalOpen,
  setPreferenceCenterOpen
} from '@/redux/cookieSlice';

export const CookieSetting = () => {
  const cookie = useSelector((state: any) => state.cookie);
  const dispatch = useDispatch();
  const style = {
    bottom: '40px',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  };
  return (
    <Modal
      open={cookie.open}
      onClose={() => dispatch(setModalOpen(false))}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        className="absolute right-0 w-full rounded-2xl bg-[rgba(48,9,134,1)] lg:bottom-0 lg:right-10 lg:h-[400px] lg:w-[500px] "
      >
        <Typography
          id="modal-modal-description"
          className="!leading-7 !tracking-wide  "
        >
          {`We use cookies to enhance your browsing experience, serve personalised
          ads or content, and analyse our traffic. By clicking "Accept All", you
          consent to our use of cookies.`}
        </Typography>
        <div className="mt-6 flex flex-col gap-4 px-4">
          <Button
            className="mx-4 flex h-[50px] w-full items-center justify-center"
            style={{
              backgroundImage:
                'linear-gradient(90deg, rgba(85, 27, 230, 1) 0%, rgba(120, 8, 237, 1) 100%)'
            }}
            onClick={() => dispatch(setCookieConfig('' as any))}
          >
            Accept All
          </Button>
          <Button
            className="mx-4 flex h-[50px] w-full items-center justify-center"
            variant="outline"
            onClick={() => dispatch(setCookieConfig('' as any))}
          >
            Reject All
          </Button>
          <Button
            className="mx-4 flex h-[50px] w-full items-center justify-center"
            onClick={() => dispatch(setPreferenceCenterOpen(true))}
          >
            Customise
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default CookieSetting;
